
const styles = theme => ({
  paper: {
    minWidth:500,
    overflow:'visible'
  }
});


export default styles;